const bundlePopup = {

    events: () => {

        let bundleBlocksTriggers    = document.querySelectorAll('.product-bundle__card [data-popup]');
        let bundleBlocksPopups      = document.querySelectorAll('.product-bundle__popup[data-popup]');

        if ( bundleBlocksTriggers && bundleBlocksPopups ) {

            [].forEach.call(bundleBlocksTriggers, function(e) {   

                e.addEventListener('click', () => {

                    let target  = e.getAttribute('data-popup');
                    let popup   = document.querySelector(`.product-bundle__popup[data-popup="${target}"]`);

                    if ( popup ) {
                        popup.classList.add('active');
                    }
                    
                });

            });

            [].forEach.call(bundleBlocksPopups, function(e) {
                let close   = e.querySelector('.product-bundle__popup--close');

                if ( close) {
                    close.addEventListener('click', () => {
                        e.classList.remove('active');
                    });
                }

            });

        }

    },

    init: () => {
        bundlePopup.events();
    }

}

window.addEventListener('DOMContentLoaded', () => {
    bundlePopup.init();
});